import $ from 'jquery';

const clone = object => JSON.parse(JSON.stringify(object));

export default class ResponseStore {

	constructor() {

		this.items = [];

		this.ready = false;

		this.loading = false;

		this.currentPage = 1;

		this.itemsPerPage = -1;

		this.filters = {};

	}

	setItems(items) {

		this.items = items;

		return this;

	}

	setLoading(loading = true) {

		if (!this.loading)

			this.loading = loading;

		return this;

	}

	setNotLoading(loading = false) {

		if (this.loading)

			this.loading = loading;

		return this;

	}

	setReady(ready) {

		if (!this.ready)

			this.ready = ready;

		return this;

	}

	setNotReady(ready = false) {

		if (this.ready)

			this.ready = ready;

		return this;

	}

	setCurrentPage(currentPage) {

		this.currentPage = currentPage;

		return this;

	}

	getCurrentPage() {

		return this.currentPage;

	}

	setItemsPerPage(itemsPerPage) {

		this.itemsPerPage = itemsPerPage;

		return this;

	}

	getItemsPerPage() {

		return this.itemsPerPage;

	}

	getItemByProperty(property, value) {

		return this.items && this.items.find(item => item[property] === value);

	}

	getItems() {

		return this.items || [];

	}

	getCheckedItems(property = '__checked__') {

		return this.getItems().filter(item => item[property]);

	}

	setUncheckedItems(check = false) {

		return this.getItems().filter(item => {
			item['__checked__'] = check;
		});

	}

	hasItems() {

		return this.getItems().length > 0;

	}

	hasNotItems() {

		return !this.hasItems();

	}

	isLoading() {

		return this.loading;

	}

	isReady() {

		return this.ready;

	}

	isNotReady() {

		return !this.isReady();

	}

	pushItems(items) {

		Array.prototype.push.apply(this.items, items);

		return this;

	}

	removeItems(items, trackBy = 'id') {

		this.items.forEach(item => item.__toRemove__ = items.some(i => item[trackBy] === i[trackBy]));

		this.items = this.items.filter((value) => !value.__toRemove__);

		return this;

	}

	// @TODO: Verificar atualização responseStore
	/**
	 * - É removido o `__busy__` sempre que da um update, pois é chamado sempre no final da requisição. Verificar se é possível usar o `setItemsAsNotBusy` na controller.
	 * - O `item.__lastModified__` foi alterado de lugar para passar antes do clone.
	 * - Adicionado o parâmetro `true` no `$.extend` dos itens para assinar recursivamente, problema ocorria na tela de usuários-clientes onde a propriedade `pessoa` que é um outro objeto dentro do objeto principal e o mesmo já possuia dados, por isso era sobrescrevido.
	 */
	updateItems(items, modified, trackBy) {

		var date = new Date;

		items.forEach(item => {

			item = this.removeItemPrivateProperties(item);

			if (modified)

				item.__lastModified__ = date;

			item.__update__ = clone(item);

			item.__toUpdate__ = true;

		});

		this.getItems().forEach(item => {

			if (trackBy ? items.map(i => i[trackBy]).includes(item[trackBy]) : item.__toUpdate__) {

				$.extend(true, item, (trackBy ? items.find(i => i[trackBy] === item[trackBy]).__update__ : item.__update__));

				delete item.__busy__;

				delete item.__update__;

				delete item.__toUpdate__;

				if (item.__clone__)

					item.__clone__ = clone(item);

				if (item.__toRowback__)

					item.__toRowback__ = false;

			}

		});

		return this;

	}

	// @TODO: Verificar atualização responseStore
	/**
	 * - Foi adicionado o parâmetro list, no caso das ações dentro aplicações, pois a lista percorrida, era sempre de aplicações, e não era possível verificar se o item action, passado como parâmetro (items), teria a propriedade __toRowback__.
	 * - Foi alterada a maneira que atribui o rowback para o item, utilizando o extend.
	 * - Foi adicionado as linhas que deletam o __toRowback__ e o __clone__, pois os mesmos já foram executados, e não faziam mais sentido ficarem no item.
	 *
	 */
	rowbackItems(items, list = this.items) {

		if (!Array.isArray(items)) items = [ items ];

		items.forEach(item => item.__toRowback__ = true);

		list.forEach((item) => {

			if (item.__toRowback__ && item.__clone__) {

				$.extend(item, item.__clone__);

				delete item.__toRowback__;

				delete item.__clone__;

			}

		});

		return this;

	}

	setItemsAsBusy(items) {

		if (!Array.isArray(items))

			items = [ items ];

		items.forEach(item => item.__busy__ = true);

		return this;

	}

	setItemsAsNotBusy(items) {

		if (!Array.isArray(items))

			items = [ items ];

		items.forEach(item => item.__busy__ = false);

		return this;

	}

	isItemBusy(item) {

		return typeof item === 'object' && item.__busy__;

	}

	setItemAsEditable(item) {

		item.__editable__ = true;

		item.__clone__ = clone(item);

		return this;

	}

	setItemAsNotEditable(item) {

		item.__editable__ = false;

		return this;

	}

	setSiblingItemsAsNotEditable(item) {

		item.__notSibling__ = true;

		this.items.filter(value => !value.__notSibling__).forEach(value => value.__editable__ = false);

		delete item.__notSibling__;

		return this;

	}

	removeItemPrivateProperties(item) {

		Object.keys(item).forEach(value => /^__[\w\d]+__$/.test(value) && delete item[value]);

		return item;

	}

	isItemEditable(item) {

		return item.__editable__;

	}

	isItemNotEditable(item) {

		return !this.isItemEditable(item);

	}

	isItemRecentlyUpdated(item) {

		return typeof item === 'object' && !!item.__lastModified__;

	}

	setFilters(filters, noConversion) {

		Object.keys(filters).forEach(filter => this.setFilter(filter, filters[filter], noConversion));

		return this;

	}

	setFilter(filter, value, noConversion) {

		if (!noConversion) {

			if (/^(?:true|false)$/.test(value))

				value = value == 'true';

			if (/^\d+(?:\.\d+)?$/.test(value))

				value = +value;

			if (value === '')

				return this;

		}

		this.filters[filter] = value;

		return this;

	}

	removeFilter(filter) {

		delete this.filters[filter];

		return this;

	}

	clearFilters() {

		this.filters = {};

		return this;

	}

	getFilters() {

		return this.filters;

	}

	getFilter(filter) {

		return this.filters[filter];

	}

	hasFilter(filter) {

		return this.filters.hasOwnProperty(filter);

	}

	hasFilters() {

		for (let filter in this.filters)

			return true;

		return false;

	}

}
